<template>
<b-container class="">
  <b-row align-h="start">
  <h1>Convert HEX to BIN</h1>
  </b-row>
  <b-row>
  <h2>Here paste the HEX</h2>
  </b-row>
  <b-row>
      <b-form-textarea id="textarea1"
                     v-model="text"
                     placeholder="Paste HEX, or drag text file here"
                     :rows="3"
                     :max-rows="6">
    </b-form-textarea>
    </b-row>
    <b-row>
      <h5>Download:</h5>
      <div class="col-sm">
        <hexinput v-model="mFrom" prepend="From"></hexinput>
      </div>
      <div class="col-sm">
        <hexinput v-model="mTo" prepend="To"></hexinput>
      </div>
      <div class="col-sm"><b-input-group size="mb" prepend="Filename">
        <b-form-input v-model="fname" class="text-right"></b-form-input>
          <div class="input-group-append">
            <span class="input-group-text">.bin</span>
          </div>
        </b-input-group></div>
    </b-row>
  <b-row>
  <b-button @click="dl"  class="col-sm-3" variant="primary">Download as .BIN ({{mTo - mFrom + 1}} bytes)</b-button>
  <b-button v-on:click="clearMemory" class="col-sm-2" variant = "danger">Clear all</b-button>
  </b-row>
</b-container>
</template>

<script>

import hexinput from './visual/hexinput.vue'

var download = function (filename, arr, from, to) {
  var text = '';
  for (var i = from; i <= to; i++) {
    text += String.fromCharCode(arr[i]);
  }
  var pom = document.createElement('a');
  pom.setAttribute('href', 'data:application/octet-stream;base64,' + btoa(text));
  pom.setAttribute('download', filename);
  document.body.appendChild(pom);
  pom.click();
  document.body.removeChild(pom);
};

var doDrag = function (_this) {
  var holder = document.getElementById('textarea1')

  holder.ondragover = function () {
    this.className = 'form-control';
    return false;
  };
  holder.onmouseleave = function () {
    this.className = 'form-control';
    return false;
  };
  holder.ondrop = function (e) {
    this.className = 'form-control';
    e.preventDefault();

    var file = e.dataTransfer.files[0]
    var reader = new FileReader();
    reader.onload = function (event) {
      _this.text = event.target.result;
    };
    reader.readAsText(file);

    return false;
  };
}

var hexLine = function (ln) {
  let out = {}
  if (ln[0] !== ':') return false;
  var len = parseInt(ln[1] + ln[2], 16);
  var start = parseInt(ln[3] + ln[4] + ln[5] + ln[6], 16);
  var typ = parseInt(ln[7] + ln[8], 16);
  out.len = len
  out.start = start
  if (typ === 0) {
    out.data = [];
    for (let i = 0; i < len; i++) {
      out.data[i] = parseInt(ln[9 + 2 * i] + ln[10 + 2 * i], 16);
    }
  }
  return out;
}

var pad = function (data, mode, len = 2) {
  if (mode === 'dec') return data;
  let n = data.toString(16).toUpperCase();
  while (n.length < len) n = '0' + n;
  if (mode === 'hex') return '$' + n
  if (mode === '0x') return '0x' + n
  if (mode === 'xxx') return n
}

export default {
  name: 'hex2bin',
  components: {hexinput},
  data () {
    return {
      text: '',
      fname: 'convert',
      mFrom: 0,
      mTo: 65535,
      memory: []
    }
  },
  watch: {
    text () {
      // had to parse!
      // console.log(val)
      var ln = this.text.split('\n');
      this.memory = [];
      this.memory[65535] = 0;
      var amin = 65535;
      var amax = 0;
      for (let i = 0; i < ln.length; i++) {
        let hl = hexLine(ln[i]);
        if (!hl) continue;
        if (hl.len === 0) continue;
        if (amin > hl.start) amin = hl.start;
        if (amax < (hl.start + hl.len)) amax = hl.start + hl.len;
        for (let j = 0; j < hl.len; j++) {
          this.memory[hl.start + j] = hl.data[j]
        }
      }
      if (amin > amax) {
        this.mFrom = amax;
        this.mTo = amin;
      } else {
        this.mFrom = amin;
        this.mTo = amax;
      }
    }
  },
  methods: {
    clearMemory () {
      this.memory = [];
      this.memory[65535] = 0;
      this.mFrom = 0;
      this.mTo = 65535;
      this.text = '';
    },
    dl () {
      download(this.fname + '.bin', this.memory, this.mFrom, this.mTo)
    }
  },
  computed: {
    textout: {
      get () {
        var ln = this.text.split('\n')
        var out = '';
        var org = null;

        if (this.format === 'asm') {
          for (let i = 0; i < ln.length; i++) {
            let hl = hexLine(ln[i]);
            if (!hl) continue;
            if (hl.len === 0) continue;
            if (org !== hl.start) {
              out += '    .org ' + pad(hl.start, this.mode, 4) + '\n';
              org = hl.start;
            }
            out += '    .db '
            for (let j = 0; j < hl.len; j++) {
              out += pad(hl.data[j], this.mode)
              if (j < (hl.len - 1)) out += ', '
            }
            out += '\n'
            org += hl.len
          }
        }

        if (this.format === 'js') {
          let mode = this.mode
          if (mode === 'hex') mode = '0x'
          for (let i = 0; i < ln.length; i++) {
            let hl = hexLine(ln[i]);
            if (!hl) continue;
            if (hl.len === 0) continue;
            if (org !== hl.start) {
              if (org !== null) { out += '];\n' }
              out += 'var n_' + pad(hl.start, 'xxx', 4) + ' = [\n';
              org = hl.start;
            }
            out += '/* ' + pad(org, 'xxx', 4) + ' */  '
            for (let j = 0; j < hl.len; j++) {
              out += pad(hl.data[j], mode)
              out += ', '
            }
            out += '\n'
            org += hl.len
          }
          if (org) out += '];\n'
        }

        return out;
      },
      set () { return }
    }
  },
  mounted () {
    doDrag(this)
  }
}
</script>

<style>
textarea {font-family: monospace !important;}
</style>
